import Abstract from './Abstract.js';

export default class Modal extends Abstract {
  constructor(props) {
    super(props);
  }

  addModal() {
    const {
      chart,
      options: { onShowMilestoneModal },
    } = this.props;
    chart
      .selectAll('.modal-mile')
      .on('click', (d) => onShowMilestoneModal(d.childMilestone));
  }

  build() {
    this.addModal();
  }
}
